import React from 'react'
import cx from 'classnames'

import BlockContent from 'src/components/global/BlockContent'
import { SmallCaret } from 'src/components/svgs'

import { Serializer } from 'src/utils/serializer'
import { FAQProps } from './interfaces/FAQ'

export const Faqs = ({ data }: { data: FAQProps }) => {
  const { title, cta, faqs, backgroundColor, deepLinkId } = data

  // get schema for each question and answer
  const mainEntities = faqs
    .filter(faq => faq.question)
    ?.map(faq => {
      let answerText = ''
      faq.answer.forEach(answer => {
        answer.children.forEach(child => {
          if (child.text) {
            answerText += child.text
          }
        })
      })

      return {
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: `${answerText}`,
        },
      }
    })
    .filter(entity => entity.acceptedAnswer.text.length > 0) // Filter out empty answers

  return (
    <>
      <script
        key="json-ld"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: mainEntities,
          }).replace(/</g, '\\u003c')
        }}
      />

      <div
        id={deepLinkId}
        className={cx('rel pys', backgroundColor, {
          cw: backgroundColor === 'bcb',
        })}
      >
        <div className="container--l mmb20 mxa outer p1">
          <h2 className="module-title-serif mt0 pt0">{title}</h2>
          <div className="mb1 pb0">
            {faqs?.map(faq => (
              <details
                key={faq._id}
                // @ts-expect-error - name is valid HTML5 but not in React types yet
                name="faq-accordion"
                className="rel mb1 br faq__single bcw cb"
              >
                <summary className="ss20 sm21 p1 pb0 py0 m0 cursor faq__summary">
                  <span className="faq__summary-text">{faq.question}</span>
                  <SmallCaret className="faq__summary-icon" />
                </summary>
                <div className="faq__answer">
                  <div className="px1">
                    <BlockContent
                      blocks={faq.answer}
                      serializers={Serializer}
                    />
                  </div>
                </div>
              </details>
            ))}
          </div>
          {cta && (
            <a
              href="https://intercom.help/ask-tia/en/"
              target="_blank"
              className="inline-block mt0 button button--transparent-b"
            >
              {cta}
            </a>
          )}
        </div>
      </div>
    </>
  )
}

export default Faqs
